/**
 * Filename for the membership-frontend FCM service worker (Nitro route + client registration).
 * Must differ from legacy `firebase-messaging-sw.js` so `sw-cleanup` can unregister the old app
 * without removing the current worker.
 */
export const FCM_SERVICE_WORKER_SCRIPT = 'cp-firebase-messaging-sw.js'

export function fcmServiceWorkerPath(): string {
  return `/${FCM_SERVICE_WORKER_SCRIPT}`
}

export function isFcmServiceWorkerScriptUrl(url: string | undefined | null): boolean {
  if (!url) return false
  return url.endsWith(`/${FCM_SERVICE_WORKER_SCRIPT}`)
}
